import "./Services.module.css";
import Header from "@/reusable_sections/Header";
import ServiceOverview from "./sections/ServiceOverview";
import DetailedServiceCards from "./sections/DetailedServiceCards";
import GetStartedConsultation from "./sections/GetStartedConsultation";
import Footer from "@/reusable_sections/Footer";
export default function ServicesPage() {
  return <div>
      <Header />
      <ServiceOverview />
      <DetailedServiceCards />
      <GetStartedConsultation />
      <Footer />
    </div>;
}